import React from 'react';
import { useAuth } from '@/context/AuthContext';

/**
 * Renders one page for signed-in customers and another for guests (magic-link / return-exchange
 * sessions, loginType "token"). Guests keep the original order pages, which run the return flow.
 */
const ByLoginType: React.FC<{ customer: React.ReactNode; guest: React.ReactNode }> = ({ customer, guest }) => {
  const { loginType } = useAuth();
  return <>{loginType === 'token' ? guest : customer}</>;
};

export default ByLoginType;
